<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="p-2">
      <b-col>
        <b-form inline>
          <b-form-select
            style="min-width:200px;"
            class="m-1"
            :options="orgList"
            v-model="queryParam.orgId"
            v-if="showOrg"
            placeholder="请选择机构"
          ></b-form-select>
          <b-form-select
            style="min-width:130px;"
            class="m-1"
            :options="entList"
            v-model="queryParam.entCode"
          ></b-form-select>
          <b-form-select
            class="m-1"
            :options="dateRangeList"
            v-model="queryParam.statType"
            placeholder="时间类型"
          ></b-form-select>

          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="月份"
            v-model="queryParam.month"
          ></b-form-input>

          <b-button variant="outline-primary" @click="query" class="m-1">检查</b-button>
          <b-button variant="primary" @click="exportZip" class="m-1">导出</b-button>
        </b-form>
      </b-col>
    </b-row>

    <!-- 列表1 -->
    <div class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(paperNotFound)="data">
          <b-link @click="detail(data.item, '1')">{{ data.item.paperNotFound }}</b-link>
        </template>

        <template v-slot:cell(paperError)="data">
          <b-link @click="detail(data.item, '2')">{{ data.item.paperError }}</b-link>
        </template>

        <template v-slot:cell(xmlError)="data">
          <b-link @click="detail(data.item, '3')">{{ data.item.xmlError }}</b-link>
        </template>


      </b-table>
    </div>

    <!-- 列表2 -->
    <div class="mt-2">
      <b-table
        id="data-table-2"
        responsive
        hover
        :fields="fields2"
        :items="items2.data"
        :busy="tableLoading2"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
        caption-top
        v-if="showTable2"
      >

        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template #table-caption>{{tableCaption}}</template>

        <template v-slot:cell(invCode)="data">
          {{data.item.invCode+'-'+data.item.invNo}}
        </template>

        <template v-slot:cell(fileSubmitter)="data">
          {{data.item.fileSubmitter+'('+data.item.fileSubmitterName+")"}}
        </template>

        <template v-slot:cell(fileOriginalName)="data">
          <b-link @click="handleView(data.item)">{{ data.item.fileOriginalName }}</b-link><span v-if="!data.item.fileOriginalName">无</span>
        </template>

        <template v-slot:cell(actions)="data">
          <b-link @click="showUploadFileDialog(data.item)">上传</b-link>
        </template>

      </b-table>
    </div>
    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam2.page"
        :per-page="queryParam2.size"
        :total-rows="items2.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items2.totalElements}}&nbsp;条</div>
    </div>

    <!-- 发票上传对话框 -->
    <b-modal
      id="uploadFileModal"
      title="上传发票"
      incline
      v-model="uploadFileDialogVisible"
      @ok="handleUploadFile"
    >
      <template slot="modal-ok">立即上传</template>
      <template slot="modal-cancel">取消</template>
      <b-form-group label="文件" label-cols="3">
        <b-form-file
          v-model="uploadParam.file"
          :state="Boolean(uploadParam.file)"
          accept="image/*, .pdf, .ofd"
          placeholder="请选择一个文件..."
          drop-placeholder="将文件拖放到这里..."
        ></b-form-file>
      </b-form-group>
    </b-modal>

    <loading :show="pageLoading"></loading>


  </div>
</template>

<script>
import * as paperStatFacade from "../../../api/paper-stat-facade.js";
import * as orgFacade from "../../../api/org-facade.js";
import * as entFacade from "../../../api/ent-facade.js";
import { mapState } from "vuex";

export default {
  // validations:
  data() {
    return {
      orgList: [
        { text: "机构", value: "" },
        { text: "机构一", value: "1" }
      ],
      dateRangeList: [
        { text: "接收时间", value: "0" },
        { text: "记账时间", value: "1" },
      ],
      entList: [{ text: "受票方", value: "" }],
      

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      queryParam: {
        orgId: "",
        entCode: "",
        statType: "0",
        month: new Date().getFullYear() 
      },

      items:[],
      tableCaption:"",
      //上传参数
      uploadParam: {
        invoiceId: "",
        file: null
      },

      // 以上为数据展示和传输对象

      // 以下为页面状态控制参数
      showOrg: false,
      pageLoading: false,
      tableLoading: false,
      tableLoading2: false,
      showTable2: false,
      uploadFileDialogVisible: false,

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      // 以下为表单校验规则

      // 以上为表单校验规则
      fields: [
        {
          key: "cataName",
          label: "类型"
        },
        {
          key: "total",
          label: "总数"
        },
        {
          key: "paperNotFound",
          label: "版式文件缺失"
        },
        {
          key: "paperError",
          label: "版式文件错误"
        },
        {
          key: "xmlError",
          label: "xml文件错误"
        },
      ],

      fields2: [
      {
          key: "invCode",
          label: "发票代码-号码"
        },
        {
          key: "sellerName",
          label: "开票方"
        },
        {
          key: "issueDate",
          label: "开票日期"
        },
        {
          key: "totalAmount",
          label: "金额"
        },
        {
          key: "fileSubmitter",
          label: "提交人"
        },
        {
          key: "uploadTime",
          label: "提交时间"
        },
        {
          key: "fileOriginalName",
          label: "版式文件",
        },
        {
          key: "paperErrorMsg",
          label: "错误原因",
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 分页查询的参数
      items2: {
        totalElements: 0,
        data: []
      },
      queryParam2: {
        size: 10,
        page: 1,
        criteria: {
          orgId: "",
          entCode: "",
          statType: "",
          month: "",
          paperStatus: "",
        },
        sortOrder: { createTime: "descending" }
      },


    };
  },
  watch: {
    "queryParam.orgId"() {
      if (this.queryParam.orgId) {
        entFacade
          .findByOrgId(this.queryParam.orgId)
          .then(res => {
            this.parseEntInfo(res);
          })
          .catch(err => {
            console.log("err", err);
            this.pageLoading = false;
          });
      }
    }
  },

  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    this.initInfo();
  },
  mounted() {
    // 异步加载列表数据
    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {
    // 根据查询条件检索数据
    query(){

      this.showTable2=false
      this.tableLoading = true; // 打开表格的Loading状态
      paperStatFacade
        .invPaperStat(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
          if(res.length==0){
            this.$message({
              message: "没有检索到发票信息",
              type: "danger"
            });

          }
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    list(page){
      if (page) {
        this.queryParam2.page = page;
      }

      paperStatFacade
        .pageList(this.queryParam2) // 异步调用后台接口
        .then(res => {
          this.items2 = res; // 为表格填充数据
          this.tableLoading2 = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading2 = false;
        });

    },

    detail(dataItem, paperStatus){
      this.tableLoading2 = true; // 打开表格的Loading状态
      this.queryParam2.criteria = this.queryParam;
      this.queryParam2.criteria.paperStatus = paperStatus;
      this.queryParam2.criteria.cataCode = dataItem.cataCode;

      this.tableCaption = dataItem.cataName;
      this.showTable2=true

      this.list(1)
    },

    exportZip(){

      paperStatFacade
        .eidownloads(this.queryParam) // 异步调用后台接口
        .then(response => {
          // var blob = new Blob([response.data])
          // console.log(blob)
          // if (response.headers['content-type'] === 'APPLICATION/OCTET-STREAM') {
          let filename = "归档发票.zip";
          //response.data为下载的文件数据
          let url = window.URL.createObjectURL(new Blob([response]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          // }
        });

    },

    // 打开上传文件对话框
    showUploadFileDialog(invDto) {
      this.uploadFileDialogVisible = true;
      this.uploadParam.invoiceId = invDto.id;
    },

        // 执行文件上传
    async handleUploadFile() {
      this.pageLoading = true;
      let file = this.uploadParam.file;

      if(file.size < 1048576){
          var data = new FormData();
          data.append("invoiceId", this.uploadParam.invoiceId);
          data.append("file", file, file.name);

          // 执行文件上传
          paperStatFacade
            .uploadFile(data)
            .then(() => {

              // 上传完成后，重新刷新
              this.pageLoading = false;
              this.$message({
                message: "发票文件上传成功",
                type: "success"
              });

              this.list();
              this.uploadFileDialogVisible = false;

            })
            .catch(err => {
              this.pageLoading = false;
              console.log("err", err);
            });
        }else{
          this.pageLoading = false;
          this.$message({
                message: "文件太大，无法上传",
                type: "danger"
              });

      }

    },

    //获取机构信息
    async getOrgInfo() {
      this.pageLoading = true;
      orgFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let orgList = [{ text: "机构", value: "" }];

          res.map(item => {
            let org = {};
            org.text = item.name;
            org.value = item.id;
            orgList.push(org);
          });
          this.orgList = orgList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //获取企业信息
    async getEntInfo() {
      this.pageLoading = true;
      entFacade
        .findByUser()
        .then(res => {
          this.parseEntInfo(res);
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //初始化信息
    initInfo() {
      let roles = this.info.roles;
      //系统管理员
      if (roles.indexOf("sys_admin") > -1) {
        this.showOrg = true;
        this.getOrgInfo();
        this.getEntInfo();
      } else {
        //机构管理员或者财务经理
        this.showOrg = false;
        this.getEntInfo();
      }

      // 设置月份
      const currentDate = new Date();
      const lastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
      this.queryParam.month = lastMonth.getFullYear() +""+ ((lastMonth.getMonth() + 1) > 9 ? (lastMonth.getMonth() + 1) : "0" + (lastMonth.getMonth() + 1));

    },
    //解析企业信息
    parseEntInfo(res) {
      this.pageLoading = false;
      let entList = [{ text: "受票方", value: "" }];
      let accEntList = [];
      if (res) {
        res.map(item => {
          let ent = {};
          ent.text = item.entName;
          ent.value = item.entCode;
          entList.push(ent);
          accEntList.push(ent);
        });
      }

      this.entList = entList;
      this.accEntList = accEntList;
      if (this.accEntList.length > 0) {
        this.accountParam.entCode = this.accEntList[0].value;
      }
    },

    //查看发票
    handleView(item) {
      if(item.fileFormat == null){
        const { href } = this.$router.resolve({
          name: "view",
          query: { c: item.id }
        });

        window.open(href, "_blank");

      }else{
        const { href } = this.$router.resolve({
          name: "viewer2",
          query: { id: item.id }
        });

        window.open(href, "_blank");
      }
    },

  },


};

</script>